import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import { thunk } from 'redux-thunk';
import App from './App';
import reducers from './reducers';
import LanguageContextProvider from './components/contexts/LanguageContext';
import ContentTranslationsContextProvider from './components/contexts/ContentTranslationsContext';
import { initSentry } from './monitoring/sentry';
import './index.css';

const store = createStore(reducers, applyMiddleware(thunk));
const container = document.getElementById('root');

initSentry();

if (!container) {
  throw new Error('Root element not found');
}

createRoot(container).render(
  <Sentry.ErrorBoundary
    fallback={
      <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
        <h1 style={{ fontSize: '1.25rem' }}>Something went wrong.</h1>
        <p>Please refresh the page to try again.</p>
        <button type="button" onClick={() => window.location.reload()}>
          Refresh
        </button>
      </div>
    }
  >
    <React.StrictMode>
      <Provider store={store}>
        <LanguageContextProvider>
          <ContentTranslationsContextProvider>
            <App />
          </ContentTranslationsContextProvider>
        </LanguageContextProvider>
      </Provider>
    </React.StrictMode>
  </Sentry.ErrorBoundary>
);
